<template>
  <div ui-view="" class="app-body" id="view">
    <agree-item
    :item="item"
    v-for="(item, index) in agreeItems" v-if="item.isEnable == 1" :key="index" @agreeCheckEvent="agreeCheckHandler" @agreeOpenEvent="agreeOpenEventHandler"/>
    <div class="mt-20">
      <small>
        <label class="md-check">
        <input type="checkbox" v-model="isCheckAll" @change="checkAllHandler">
        <i class="blue"></i>모든 약관에 동의합니다.</label>
      </small>
    </div>
    <div class="btn-wrap mt-30 justify-content-center">

      <button class="btn btn-lg line-2" @click="prev()"><i class="icon-arrow-line-left mr-5"></i>이전</button>
      <button class="btn btn-lg blue" @click="next()" :disabled="isCheckNext">다음<i class="icon-arrow-line-right  ml-5"></i></button>
    </div>
  </div>

</template>

<script>
import AgreeItem from './AgreeItem.vue';
import IdcCard from './IdcCard.vue'
export default {
  components: { IdcCard, AgreeItem },
  data(){
    return {
      agreeItems:[
        {'tosTitle' : 'IDC 출입 필수 사항', }
      ],
      checkedAll: false
    }
  },
  computed: {
    isCheckNext() {
      if(!this.agreeItems)
        return false;
      this.checkedAll = this.agreeItems.filter((item)=>{return item.isChecked}).length != this.agreeItems.length;
      return this.agreeItems.filter((item)=>{return item.isChecked}).length != this.agreeItems.length;
    },
    isCheckAll() {
      return !this.isCheckNext
    }
  },
  mounted(){

    this.loadItems();
  },
  methods: {
    prev(){

      this.$router.push({ path: '/app/main/selectIdc', query: this.getQuery()})
    },
    next(){

      this.$router.push({ path: '/app/main/inputInfo', query: this.getQuery()})
    },
    getQuery(){
      var query = Object.assign({},this.$route.query);
      var tosList = this.agreeItems.filter((item)=>{return item.isChecked});
            query.tos = JSON.stringify(_.chain(tosList)
      .keyBy('tosIndex')
      .mapValues('isChecked')
      .value());
      return query;
    },
    loadItems(){
      var that = this;
      this.$http.get('/api/tos')
        .then((result) => {

          result.data.forEach((item) => {
            item.isChecked = false;
            item.isOpen = false;
          });

          that.agreeItems = result.data.filter(x => x.isEnable==1);
        }).catch((e) =>{
      })
    },
    checkAllHandler(){
      // this.checkedAll = !this.checkedAll
      this.agreeItems.forEach((item)=>{
        // item.isChecked = !item.isChecked ;
       item.isChecked = this.checkedAll;
      })
    },
    agreeCheckHandler(data){
      var that = this;
      this.agreeItems.forEach((item)=>{
        if(data.tosIndex == item.tosIndex) {
          item.isChecked = data.isChecked;
          item.isOpen = data.isChecked
          return;
        }
      })
    },
    agreeOpenEventHandler(data) {
      var that = this;
      this.agreeItems.forEach((item)=>{
        if(data.tosIndex == item.tosIndex) {
          item.isOpen = !data.isOpen;
          return;
        }
      })
    }
  }
}
</script>

<style>

